import React, { ChangeEvent, FC } from "react";
import style from "./style.module.scss";
import validationError from "../../assets/images/validationError.svg";

interface ICustomInput {
  value: string;
  id: string;
  type?: string;
  label: string;
  placeholder?: string;
  hasFullWidth?: boolean;
  marginBottom?: string;
  regexp?: RegExp;
  width?: string;
  isDisabled?: boolean;
  onChange: (str: string) => void;
  isTouched?: boolean;
  error?: string;
  className?: string;
  ariaLabel?: string;
  onBlur?: (e: React.FocusEvent<any>) => void;
  marginRight?: string;
  customClassName?: string;
  autoComplete?: string;
  readOnly?: boolean;
  showError?: boolean;
}

export const CustomInputV2: FC<ICustomInput> = ({
  id,
  type,
  label,
  placeholder,
  hasFullWidth = false,
  marginBottom,
  regexp,
  width,
  isDisabled = false,
  onChange,
  error = "",
  isTouched = false,
  className,
  ariaLabel = "",
  value,
  onBlur,
  marginRight,
  customClassName,
  autoComplete = "off",
  readOnly,
  showError = true,
}) => {
  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) {
      return;
    }
    if (regexp) {
      if (e.currentTarget.value === "") {
        return onChange(e.target.value);
      }
      if (!regexp.test(e.currentTarget.value)) return;
    }

    onChange(e.target.value);
  };

  return (
    <div
      className={`${style.input_wrapper} ${
        hasFullWidth ? style.fullWidthInput : ""
      } ${isTouched && error ? style.input_wrapperWithWarning : ""} ${
        customClassName ? customClassName : ""
      }`}
      style={{
        marginBottom: marginBottom ? `${marginBottom}px` : "",
        width: width?.includes("%")
          ? `${width}`
          : width && !width?.includes("%")
            ? `${width}px`
            : "",
        opacity: isDisabled ? 0.5 : 1,
        marginRight: marginRight ? `${marginRight}px` : "",
      }}
    >
      {/* {label ? ( */}
      <label
        translate="no"
        className={`${style.label} ${
          isTouched && error && !isDisabled && style.labelWithWarning
        } ${className ? className : ""}`}
        htmlFor={id}
      >
        {label}
      </label>
      {/* ) : null} */}
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value ?? ""}
        className={`${style.customInput} ${
          isDisabled ? style.disabledCustomInput : ""
        } ${isTouched && error && !isDisabled && style.customInputWithWarning}`}
        onBlur={onBlur}
        onChange={changeHandler}
        aria-describedby={
          isTouched && error && !isDisabled ? `${id}-error` : undefined
        }
        aria-invalid={
          isTouched && error && !value && !isDisabled ? true : undefined
        }
        aria-label={ariaLabel}
        autoComplete={autoComplete}
        readOnly={readOnly}
      />
      {/* {isTouched && error && !isDisabled && ( */}
      {showError ? (
        <div
          className={`${style.errorMessage} ${
            isTouched && error && !isDisabled ? "" : style.disabledErrorMessage
          }`}
          id={isTouched && error && !isDisabled ? `${id}-error` : undefined}
          // role="alert"
          role={isTouched && error && !isDisabled ? "alert" : undefined}
          aria-live="assertive"
          aria-hidden={!(isTouched && error && !isDisabled)}
        >
          {error}
        </div>
      ) : null}
      {/* )} */}
      {/* {isTouched && error && !isDisabled && ( */}
      <img
        src={validationError}
        alt="err"
        className={`${style.warningImg} ${
          isTouched && error && !isDisabled ? "" : style.disabledErrorMessage
        }`}
        style={{
          top: label ? "44px" : "0",
        }}
        tabIndex={-1}
        aria-hidden="true"
      />
      {/* )} */}
    </div>
  );
};
